enum ETypographySize {
    Tiny = 12,
    ExtraSmall = 13,
    Small = 14,
    Medium = 16,
    MediumPlus = 18,
    Heading2 = 24,
    Heading1 = 36
}

enum ETypographyTag {
    Paragraph = "p",
    Span = "span",
    Heading1 = "h1",
    Heading2 = "h2",
    Heading3 = "h3",
    Heading5 = "h5",
    Heading6 = "h6",
    Div = "div"
}

enum ETypographyColor {
    Accent = "accent",
    Black = "black",
    White = "white",
    Dark = "dark",
    Gold = "gold",
    Error = "error",
    Gray23 = "gray23",
    Gray300 = "gray300",
    Gray500 = "gray500",
    Blue200 = "blue200",
    Blue300 = "blue300",
    Blue500 = "blue500"
}

enum ETypographyAlignment {
    Left = "left",
    Center = "center",
    Right = "right"
}

enum ETypographyFamily {
    Nunito = "nunito",
    DmSerif = "dmserif"
}

enum ETypographyWeight {
    Default = 300,
    Medium = 400,
    Semibold = 600,
    Bold = 800
}

export { ETypographySize, ETypographyTag, ETypographyColor, ETypographyWeight, ETypographyAlignment, ETypographyFamily }
